var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('Datepicker',{attrs:{"language":_vm.ja,"format":"yyyy年M月d日","clear-button":_vm.clearable,"calendar-button":"","calendar-button-icon":"far fa-calendar"},model:{value:(_vm._date),callback:function ($$v) {_vm._date=$$v},expression:"_date"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }